<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="产品编码" prop="productCode">
            <el-input v-model="dataForm.productCode" placeholder="产品编码" :disabled="!!dataForm.id"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品名称" prop="productName">
            <el-input v-model="dataForm.productName" placeholder="产品名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="产品分类" prop="category">
            <el-select v-model="dataForm.category" placeholder="请选择分类">
              <el-option label="按摩用品" value="按摩用品"></el-option>
              <el-option label="美容用品" value="美容用品"></el-option>
              <el-option label="足浴用品" value="足浴用品"></el-option>
              <el-option label="健身用品" value="健身用品"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="品牌" prop="brand">
            <el-input v-model="dataForm.brand" placeholder="品牌"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="规格" prop="specification">
            <el-input v-model="dataForm.specification" placeholder="规格"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位" prop="unit">
            <el-input v-model="dataForm.unit" placeholder="单位"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="采购价" prop="purchasePrice">
            <el-input-number v-model="dataForm.purchasePrice" :precision="2" :min="0" placeholder="采购价"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="销售价" prop="salePrice">
            <el-input-number v-model="dataForm.salePrice" :precision="2" :min="0" placeholder="销售价"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="成本价" prop="costPrice">
            <el-input-number v-model="dataForm.costPrice" :precision="2" :min="0" placeholder="成本价"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="最低库存" prop="minStock">
            <el-input-number v-model="dataForm.minStock" :min="0" placeholder="最低库存"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="最高库存" prop="maxStock">
            <el-input-number v-model="dataForm.maxStock" :min="0" placeholder="最高库存"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="dataForm.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="产品描述" prop="description">
        <el-input type="textarea" v-model="dataForm.description" placeholder="产品描述" :rows="3"></el-input>
      </el-form-item>
      <el-form-item label="产品图片" prop="imageUrl">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="dataForm.imageUrl" :src="dataForm.imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          id: 0,
          productCode: '',
          productName: '',
          category: '',
          brand: '',
          specification: '',
          unit: '件',
          purchasePrice: 0,
          salePrice: 0,
          costPrice: 0,
          minStock: 0,
          maxStock: 0,
          description: '',
          imageUrl: '',
          status: 1
        },
        dataRule: {
          productCode: [
            { required: true, message: '产品编码不能为空', trigger: 'blur' }
          ],
          productName: [
            { required: true, message: '产品名称不能为空', trigger: 'blur' }
          ],
          category: [
            { required: true, message: '产品分类不能为空', trigger: 'change' }
          ],
          unit: [
            { required: true, message: '单位不能为空', trigger: 'blur' }
          ],
          purchasePrice: [
            { required: true, message: '采购价不能为空', trigger: 'blur' }
          ],
          salePrice: [
            { required: true, message: '销售价不能为空', trigger: 'blur' }
          ],
          minStock: [
            { required: true, message: '最低库存不能为空', trigger: 'blur' }
          ],
          status: [
            { required: true, message: '状态不能为空', trigger: 'change' }
          ]
        },
        uploadUrl: ''
      }
    },
    mounted () {
      this.uploadUrl = this.$base + '/file/upload'
    },
    methods: {
      init (id) {
        this.dataForm = {
          id: id || 0,
          productCode: '',
          productName: '',
          category: '',
          brand: '',
          specification: '',
          unit: '件',
          purchasePrice: 0,
          salePrice: 0,
          costPrice: 0,
          minStock: 0,
          maxStock: 0,
          description: '',
          imageUrl: '',
          status: 1
        }
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http({
              url: `product/info/${this.dataForm.id}`,
              method: 'get'
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm = data.data
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: `product/${!this.dataForm.id ? 'save' : 'update'}`,
              method: 'post',
              data: {
                'id': this.dataForm.id || undefined,
                'productCode': this.dataForm.productCode,
                'productName': this.dataForm.productName,
                'category': this.dataForm.category,
                'brand': this.dataForm.brand,
                'specification': this.dataForm.specification,
                'unit': this.dataForm.unit,
                'purchasePrice': this.dataForm.purchasePrice,
                'salePrice': this.dataForm.salePrice,
                'costPrice': this.dataForm.costPrice,
                'minStock': this.dataForm.minStock,
                'maxStock': this.dataForm.maxStock,
                'description': this.dataForm.description,
                'imageUrl': this.dataForm.imageUrl,
                'status': this.dataForm.status
              }
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      },
      // 图片上传成功
      handleAvatarSuccess (res, file) {
        if (res && res.code === 0) {
          this.dataForm.imageUrl = res.url
        } else {
          this.$message.error(res.msg || '上传失败')
        }
      },
      // 图片上传前验证
      beforeAvatarUpload (file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        return isJPG && isLt2M
      }
    }
  }
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
